import type { PlanBuilding, ResolvedBuilding } from '$lib/types'

export interface RenderableBuilding {
  building: PlanBuilding
  resolved: ResolvedBuilding | null
  /** Footprint actually used for placement — falls back to 1×1 for unknowns. */
  width: number
  height: number
}

/**
 * Return the topmost building whose footprint covers the given grid square,
 * or null. Iterates back-to-front because the renderer draws front-to-back
 * (later entries paint on top — though in practice no overlap should exist).
 */
export function buildingAtGrid(
  buildings: RenderableBuilding[],
  gx: number,
  gy: number,
): RenderableBuilding | null {
  for (let i = buildings.length - 1; i >= 0; i--) {
    const b = buildings[i]
    if (
      gx >= b.building.x &&
      gx < b.building.x + b.width &&
      gy >= b.building.y &&
      gy < b.building.y + b.height
    ) {
      return b
    }
  }
  return null
}
